import { ProtectedReference } from "./ProtectedResource";

const VideoPlayer = ({ path = null, onOpened = null }) => {
  const urlParams = new URLSearchParams(window.location.search);
  let fullPath = path;
  if (!fullPath) {
    fullPath = urlParams.get("path");
  }
  const encodedResourcePath = encodeURIComponent(fullPath);

  const videoPath = `/api/questionnaire/video-stream?path=${encodedResourcePath}`;

  return (
    <div>
      <ProtectedReference
        resourcePath={encodedResourcePath}
        refrenceRender={
          <div>
            <video
              width="640"
              height="480"
              className="my-element"
              controls
              controlsList="nofullscreen nodownload"
              onPlay={() => {
                try {
                  if (onOpened && typeof onOpened === 'function') {
                    onOpened();
                  }
                } catch (e) {
                  // ignore
                }
              }}
            >
              <source src={videoPath} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        }
      />
    </div>
  );
};

export default VideoPlayer;
